import { render, staticRenderFns } from "./CollapsedGalleryComponent.vue?vue&type=template&id=c38b2efa&"
import script from "./CollapsedGalleryComponent.vue?vue&type=script&lang=js&"
export * from "./CollapsedGalleryComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports